import { observer } from 'mobx-react-lite';
import { useAutocompleteContext } from './Context';
import { Box, useBreakpointIndex } from '@apia/theme';
import { Fragment } from '@apia/theme/jsx-runtime';

export const OptionsBox = observer(() => {
  const handler = useAutocompleteContext();
  const breakpoint = useBreakpointIndex();
  const nativeSelectBreakpoint = handler.state.nativeSelectBreakpoint ?? 3;

  if (breakpoint <= nativeSelectBreakpoint) {
    return null;
  }

  return (
    <Fragment>
      {handler.state.options.map((c, i) => {
        if (c.filtered) {
          return <Fragment key={c.value} />;
        } else {
          return (
            <Box
              className={`autocomplete__option ${handler.focusedIndex === i ? 'focused' : ''} ${handler.state.readOnly ? 'readOnly' : ''}`}
              key={c.value}
              onMouseDown={(ev) => {
                ev.stopPropagation();
                ev.preventDefault();

                handler.setValue(c.value);
                handler.close();

                window.requestAnimationFrame(() => {
                  handler
                    .getAutocompleteBox()
                    ?.querySelector<HTMLElement>('input')
                    ?.focus();
                });
              }}
              data-value={c.value}
            >
              {c.label} &nbsp;
            </Box>
          );
        }
      })}
    </Fragment>
  );
});
